import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    searchFilterAccessorials,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state.KGPState.customAccessorials.isLoading,
    isLoadingOverlay: state.KGPState.customAccessorials.isLoadingOverlay,
    accessorials: state.KGPState.customAccessorials.accessorials,
    session: getSession(state),
    myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
    fieldstoHide: state.context.settings.properties.fieldsToHide || "",
    canshowPrice: state.context?.session?.properties?.canShowPrice?.toLowerCase() === "true",
});
const includeField = ["Accessorials"];
const includeRole = ["Administrator"];
interface CustomAccessorialsStyles {
    wrapper?: InjectableCss;
}

const styles: CustomAccessorialsStyles = {
    wrapper: {},
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

const AccessorialsPage: React.FC<Props> = ({
    id,
    session,
    isLoadingOverlay,
    myAccountPageLink,
    searchFilterAccessorials,
    history,
    canshowPrice,
    fieldstoHide,
}) => {
    useEffect(() => {
        let flag = false;
        if (myAccountPageLink) {
            myAccountPageLink?.children
                ?.filter(child => {
                    const title = child?.title?.trim();

                    // Safely split and normalize excluded titles
                    const excludedTitles =
                        !canshowPrice && fieldstoHide ? fieldstoHide.split(",").map(t => t.trim().toLowerCase()) : [];

                    if (!title) {
                        return true;
                    }

                    return !excludedTitles.includes(title.toLowerCase());
                })
                ?.forEach(child => {
                    includeRole.forEach((role: string) => {
                        if (includeField.includes(child.title)) {
                            if (!(session.userRoles.indexOf(role) !== -1)) {
                                flag = true;
                            }
                        }
                    });
                    return flag;
                });

            if (flag) {
                history.push("/");
            }
        }
        searchFilterAccessorials({ queryParams: { page: 1 } });
    }, [myAccountPageLink]);
    return (
        <LoadingOverlay loading={isLoadingOverlay}>
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="AccessorialsPageContainer" />
            </StyledWrapper>
        </LoadingOverlay>
    );
};

const accessorialsPageWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(AccessorialsPage)),
    definition: {
        group: "Basic",
    },
};

export default accessorialsPageWidget;
